import React from 'react';
import './Terms.css';

function Terms() {
    return (
        <div>
            <div className="banner-area banner-bg-1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="banner">
                                <h2>Terms Of Service</h2>
                                <ul className="page-title-link">
                                    <li><a href="#">Home</a></li>
                                    <li><a href="#">Terms Of Service</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="terms-container">
                {/* <h1>Privacy Policy</h1> */}
                <div className="terms-content">

                    <p>
                        Before you proceed with myPiggycoins, it is imperative that you must read its terms and conditions. By using its services you are agreeing to be bound with its terms & conditions.
                    </p>

                    <p>
                        This is an AGREEMENT between myPiggycoins (The LLP)  and YOU or THE ENTITY THAT YOU REPRESENT (You or Your entity) that myPiggycoins provides you the online technical services and YOU use it to lawfully benefit your business.
                    </p>



                    <p>
                        <strong>Eligibility</strong>
                    </p>

                    <p>
                        To access and use our service, you must be at least 18 years of age. All the information provided by you at the time of registration should be the accurate and latest one. Only you will be solely responsible to maintain the privacy of your service account including all the activities of the same. We reserve the right to restrict anyone from using our service without any prior notice.

                    </p>



                    <p>
                        <strong>Changes in Fees and Service</strong>
                    </p>

                    <p>
                        myPiggycoins holds the right to make changes in the fees of service. Additionally, the LLP could change, suspend or terminate any service at any time.

                    </p>

                    <p>
                        <strong>Warranties and Liability</strong>
                    </p>

                    <p>
                        myPiggycoins, the LLP, does not give warranties on the following conditions
                        <ul>
                            <li>Our service will surely meet your requirements and expectations.The service will be timely, uninterrupted and will be completely error-free.The calculation of our service will be highly accurate.</li>
                        </ul>

                    </p>
                    <p>
                        You must understand that all our services are based on an "as is" basis.

                    </p>
                    <p>
                        We are not liable for any direct, indirect exemplary, consequential or incidental damages. Also any damages for loss of profits, goodwill, and data resulting from the usage of our service will not be our part.

                    </p>



                    <p>
                        <strong>Intellectual Property Rights</strong>
                    </p>

                    <p>
                        We acknowledge to our users that myPiggycoins owns all rights, titles and interests in the services it provides. All such rights are protected by international intellectual property laws. You are restricted from copying, reproducing, and changing anything from our service part. Furthermore, the use of robots, automated devices, spiders and manual processes to monitor or copy the content is not allowed.

                    </p>

                    <p>
                        <strong>Proper use of our content/Service</strong>
                    </p>

                    <p>
                        Under this term, you agree that you will use our service in compliance with all applicable local, state, national and international laws. You are not authorized to encourage any third party to use the service with the intention of misuse of the same. Furthermore, the uploading, transmitting and distributing of the content that comes in the category of fraudulent, obscene, defamatory, unlawful, containing the virus is totally restricted. In case if any party tries to exploit any part of the service, reselling, duplicating, reproducing the same without the permission of myPiggycoins may result in termination of service. Additionally, the organization reserves the right to post federal penalties and legal consequences.
                    </p>

                    <p>
                        <strong>Payment</strong>
                    </p>

                    <p>
                        All our technical services come under a subscription plan and will charge a certain amount. The charges are applicable as per the key features included in that. Our mode of payment covers credit cards and other online payment platforms. If you hire any of our professional resources on an hourly basis then the rates will be defined accordingly. We reserve the right to change our service charges from time to time. Therefore, no user could raise the problem for the same.

                    </p>

                    <p>
                        <strong>Trademark</strong>
                    </p>

                    <p>
                        The myPiggycoins logo is an individual presenting icon of our firm and services. Therefore, no individual or firm is allowed to display or use such icons for personal and professional work without our knowledge.
                    </p>

                    <p>
                        <strong>Communication from myPiggycoins</strong>
                    </p>

                    <p>
                        Our service will also contain some communication factors in the form of service announcements, newsletters and administrative messages. This will be part of our service and working strategy. We also provide you with the opting-out option that will stop receiving a newsletter from our side.
                    </p>

                    <p>
                        <strong>Signup obligations</strong>
                    </p>

                    <p>
                        As an end-user, you need to sign up for the user account that provides all the required information. This will be help access all the services. In case if you are an organization and using our service for corporate benefit. Then we recommend using the official email Id. We also urge you to provide complete and accurate data while accessing our services. myPiggycoins have full right to terminate your account in case if any information is found to be incomplete, untrue or outdated.
                    </p>
                    <p>
                        We here declare that any new feature or tool that is added to our present service will also be subject to our terms of services. We, therefore, reserve the right to make changes in our Terms of Service by posting updates. Therefore, we urge our users/clients to periodically visit our platform and get well aware of T&C of our services.
                    </p>
                    <p>
                        In case if you have any queries or concerns related to our terms and conditions then you may contact <a href="contact" rel="noopener noreferrer">myPiggycoins</a> at <a href="mailto:ma@mypiggycoins.com" rel="noopener noreferrer">ma@mypiggycoins.com</a>.

                    </p>

                </div>
            </div>
        </div>
    );
}

export default Terms;